import { t } from '@lingui/core/macro';
import { Falcon } from '@pocketlaw/tetris/macro';
export const getStatusTranslations = () => ({
    todo: {
        icon: <Falcon icon="circle"/>,
        label: t({ message: 'Todo', comment: 'Status of a task' }),
        appearance: 'secondary',
    },
    in_progress: {
        icon: <Falcon icon="circle-half-stroke"/>,
        label: t({ message: 'In progress', comment: 'Status of a task' }),
        appearance: 'primary',
    },
    completed: {
        icon: <Falcon icon="circle-check"/>,
        label: t({ message: 'Completed', comment: 'Status of a task' }),
        appearance: 'success',
    },
});
